import { Component, createRef } from 'preact';

// A single-line label that shrinks its font size until it fits the padded
// width of its parent. For controls whose width is fixed by the layout (the
// End Turn button matches the HUD column above it) and whose label changes
// length with the language. Measures the natural width, scales the font
// down to the available width, and never wraps or grows the parent.
export class FitText extends Component {
  ref = createRef();
  state = { scale: 1 };

  componentDidMount() {
    this.fit();
    if (typeof ResizeObserver !== 'undefined' && this.ref.current?.parentElement) {
      this.observer = new ResizeObserver(() => this.fit());
      this.observer.observe(this.ref.current.parentElement);
    }
  }

  componentDidUpdate(prev) {
    if (prev.children !== this.props.children) this.fit();
  }

  componentWillUnmount() {
    this.observer?.disconnect();
  }

  fit() {
    const el = this.ref.current;
    const parent = el?.parentElement;
    if (!el || !parent) return;
    const cs = getComputedStyle(parent);
    const available = parent.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
    const natural = el.offsetWidth / this.state.scale;
    if (!(available > 0) || !(natural > 0)) return;
    const scale = Math.max(this.props.min ?? 0.6, Math.min(1, available / natural));
    if (Math.abs(scale - this.state.scale) > 0.01) this.setState({ scale });
  }

  render({ children, className, style, min, ...rest }, { scale }) {
    return (
      <span ref={this.ref} className={className} style={{ display: 'inline-block', whiteSpace: 'nowrap', fontSize: `${scale}em`, ...style }} {...rest}>
        {children}
      </span>
    );
  }
}
